import { Link } from "react-router-dom"
import { FormResponseMessage } from "../FormResponseMessage"
import { AuthMessage } from "@/constants/auth/auth"
import { Message, MessageTitle } from "@/constants/message/message"
import { SupportLink } from "../Link/SupportLink"

export const ResponseMessageBox = ({ messageTitle }: { messageTitle: string }) => {
  const linkClassname = "text-sm text-accent underline font-semibold h-1"
  const subtitleClassName = "font-normal text-left"

  const getRespectiveMessageComponent = (errorTitle: string) => {
    switch (errorTitle as AuthMessage) {
      case AuthMessage.USER_DOES_NOT_EXIST:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.USER_DOES_NOT_EXIST]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              If you are new here, please <Link to='/signup' className={linkClassname}>Sign Up </Link>first.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.INVALID_CREDENTIALS:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.INVALID_CREDENTIALS]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              If you forgot your password, you can <Link to='/forgot-password' className={linkClassname}>reset here.</Link>
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.EMAIL_ALREADY_EXISTS:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.EMAIL_ALREADY_EXISTS]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please try with different email.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.PASSWORD_TOO_SHORT:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.PASSWORD_TOO_SHORT]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Password must be at least 8 letters long.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.INVALID_TIMEZONE:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.INVALID_TIMEZONE]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Timezone is not supported.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.UNABLE_TO_FETCH:
      case AuthMessage.INTERNAL_SERVER_ERROR:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.INTERNAL_SERVER_ERROR]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please try again in some moment.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.PASSWORD_RESET_LINK_SENT:
        return (
          <FormResponseMessage
            type={Message.SUCCESS}
            showIcon={true}
            title={MessageTitle[AuthMessage.PASSWORD_RESET_LINK_SENT]}
            className="w-full"
          >
            <div className={subtitleClassName}>

              Password reset instructions has been sent to the email.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.PASSWORD_RESET_SUCCESSFUL:
        return (
          <FormResponseMessage
            type={Message.SUCCESS}
            showIcon={true}
            title={AuthMessage.PASSWORD_RESET_SUCCESSFUL}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please use your email and new password to login.
              If you have any questions please contact us at <SupportLink />.
              Welcome back!
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.TOO_MANY_ATTEMPTS:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.TOO_MANY_ATTEMPTS]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please try again in some moment.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.INVALID_TOKEN:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.INVALID_TOKEN]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              It looks like the link you clicked is invalid or expired.
              If you are trying to reset your password, please request another link <Link to='/forgot-password' className={linkClassname}>here</Link>
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.TOKEN_EXPIRED:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.TOKEN_EXPIRED]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please retry resetting your password from <Link to='/forgot-password' className={linkClassname}>here</Link>.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.PASSWORD_RESET_TOKEN_VERIFICATION_FAILED:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.PASSWORD_RESET_TOKEN_VERIFICATION_FAILED]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please retry resetting your password from <Link to='/forgot-password' className={linkClassname}>here</Link>.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.INVITATION_ACCEPTED:
        return (
          <FormResponseMessage
            type={Message.SUCCESS}
            showIcon={true}
            title={MessageTitle[AuthMessage.INVITATION_ACCEPTED]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              Please login to continue.
            </div>
          </FormResponseMessage>
        )
      case AuthMessage.INVITATION_ERROR:
        return (
          <FormResponseMessage
            type={Message.ERROR}
            showIcon={true}
            title={MessageTitle[AuthMessage.INVITATION_ERROR]}
            className="w-full"
          >
            <div className={subtitleClassName}>
              An error occured while accepting invitation. Please try again in some moment.
            </div>
          </FormResponseMessage>
        )
      default:
        break
    }
  }

  return getRespectiveMessageComponent(messageTitle)
}
